// Somali translations
export const so: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Macaamiisha',
  'menu.products': 'Badeecada',
  'menu.users': 'Isticmaalayaasha',
  'menu.settings': 'Dejinta',
  'menu.logout': 'Ka Bax',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Amar Cusub',
  'order.title': 'Amar Cusub',
  'order.customer': 'Macmiil',
  'order.products': 'Badeecada',
  'order.total': 'Wadarta',
  'users.title': 'Isticmaalayaasha',
  'users.name': 'Magaca',
  'users.email': 'Iimaylka',
  'common.yes': 'Haa',
  'common.no': 'Maya',
  'common.cancel': 'Jooji',
  'common.save': 'Keydi',
  'common.search': 'Raadi',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Gal',
  'login.welcome': 'Soo dhowow, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Iimaylka',
  'signup.phone': 'Taleefanka',
  'menu.reportsAndAccounting': 'Warbixinno & Xisaabaad',
  'menu.systemAndCommunication': 'Nidaam & Isgaarsiin',
};